export const triggerUpdate = () => {
  const reactFlowPaneElem = document.getElementsByClassName(
    "react-flow__pane"
  )[0] as HTMLElement;
  reactFlowPaneElem.click();
};
